import { render, staticRenderFns } from "./PassengerListRow.vue?vue&type=template&id=44230459"
import script from "./PassengerListRow.vue?vue&type=script&lang=ts"
export * from "./PassengerListRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports